//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'goods-item',
  components: {},
  props: ['data'],
  mounted() {
  },
  methods: {
    click() {
      this.$emit('click');
    }
  },
  data() {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/components/app/goodsItem.vue